import Chevron from 'assets/icons/chevron-r.svg';
import IconButton from 'components/controls/buttons/icon-button';
import styles from 'components/collection/modal-viewer/controls/controls.module.scss';
import { type MouseEventHandler } from 'react';

const PaginationControls = ({
	isRightToLeft,
	previousButtonRef,
	showPreviousButton,
	nextButtonRef,
	showNextButton,
	handleForwardArrowClick,
	handleBackArrowClick,
}: IProps) => {
	return (
		<div className={`${styles.buttonGroup} ${isRightToLeft ? styles.rtl : ''}`}>
			<IconButton
				className={`${styles.button} ${isRightToLeft ? styles.forwardButton : styles.backButton}`}
				data-testid="previous-slide-button"
				disabled={!showPreviousButton}
				icon={<Chevron />}
				label="Previous button"
				onClick={handleBackArrowClick}
				ref={previousButtonRef}
			/>
			<IconButton
				className={`${styles.button} ${isRightToLeft ? styles.backButton : styles.forwardButton}`}
				data-testid="next-slide-button"
				disabled={!showNextButton}
				icon={<Chevron />}
				label="Next button"
				onClick={handleForwardArrowClick}
				ref={nextButtonRef}
			/>
		</div>
	);
};

interface IProps {
	handleBackArrowClick: MouseEventHandler;
	handleForwardArrowClick: MouseEventHandler;
	isRightToLeft?: boolean;
	nextButtonRef: any;
	previousButtonRef: any;
	showNextButton: boolean;
	showPreviousButton: boolean;
}

export default PaginationControls;
